import { Stack, Box } from '@mui/material';
import { Card, CardMedia } from '../common/Card/index.js';
import { PLACEHOLDER_IMAGES } from '../../constants/images';
import { EXTERNAL_LINKS } from '../../constants/links';

const DownloadSection = () => {
  const downloads = [
    {
      platform: 'browser',
      image: PLACEHOLDER_IMAGES.downloads.browser,
      link: EXTERNAL_LINKS.browser,
      alt: 'Play in Browser'
    },
    {
      platform: 'google',
      image: PLACEHOLDER_IMAGES.downloads.google,
      link: EXTERNAL_LINKS.google,
      alt: 'Get it on Google Play'
    },
    {
      platform: 'appstore',
      image: PLACEHOLDER_IMAGES.downloads.appstore,
      link: EXTERNAL_LINKS.appstore,
      alt: 'Download on App Store'
    }
  ];

  return (
    <Box sx={{ width: { xs: '100%', md: '33.33%' }, display: 'flex', flexDirection: 'column' }}>
      <Stack direction="column" spacing={2} sx={{ width: '100%' }}>
        {downloads.map(({ platform, image, link, alt }) => (
          <Box key={platform} sx={{ width: '100%', '&:hover': { transform: 'none' } }}>
            <Card
              href={link}
              height={120}
              bgColor="black"
            >
              <CardMedia 
                image={image}
                alt={alt}
              />
            </Card>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default DownloadSection; 